import { render, staticRenderFns } from "./FollowUpPatiant.vue?vue&type=template&id=467844d3&scoped=true&"
import script from "./FollowUpPatiant.vue?vue&type=script&lang=js&"
export * from "./FollowUpPatiant.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpPatiant.vue?vue&type=style&index=0&id=467844d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467844d3",
  null
  
)

export default component.exports